const publicUrl = process.env.PUBLIC_URL || "";

export const EXERCISES = [
  {
    id: "tree-pose",
    name: "Tree Pose",
    short: "Balance",
    emoji: "🙏",
    imageUrl: `${publicUrl}/tree.jpeg`,
    description: "A standing yoga pose that improves balance, focus, and ankle stability.",
    youtubeUrl: "https://youtu.be/_u3NOB8pZf8?si=QZ3i70fQrfC3hd8G",
    difficulty: "Beginner",
    muscles: ["Core", "Ankles", "Glutes", "Hip Flexors"],
    sets: "3 sets",
    reps: "30–60 sec hold",
    calories: "~4 kcal/min",
    checklist: [
      "Stand tall — keep your spine straight and shoulders relaxed",
      "Press your foot firmly into your inner thigh or calf (not knee)",
      "Fix your gaze on a still point directly in front of you",
      "Keep your hips level and facing forward",
    ],
  },
  {
    id: "plank",
    name: "Plank",
    short: "Core",
    emoji: "🧍‍♀️",
    imageUrl: `${publicUrl}/Plank.jpg`,
    description: "A core-strength move that engages your abs, shoulders, and glutes in one hold.",
    youtubeUrl: "https://youtu.be/pvIjsG5Svck?si=1I7FvBx39s8vJ1Bn",
    difficulty: "Beginner",
    muscles: ["Abs", "Shoulders", "Glutes", "Lower Back"],
    sets: "3 sets",
    reps: "20–60 sec hold",
    calories: "~5 kcal/min",
    checklist: [
      "Keep your body in a straight line from head to heels",
      "Engage your core — don't let your hips sag or rise",
      "Look down at the floor to keep your neck neutral",
      "Breathe steadily throughout the hold",
    ],
  },
  {
    id: "bicep-curl",
    name: "Bicep Curl",
    short: "Arms",
    emoji: "💪",
    imageUrl: `${publicUrl}/BIC2.jpeg`,
    description: "Targets the front of your upper arms with controlled curling of the weights.",
    youtubeUrl: "https://youtu.be/cBSD6mQIPQk?si=QLC1LmQVTWOWOefB",
    difficulty: "Beginner",
    muscles: ["Biceps", "Forearms", "Shoulders"],
    sets: "3 sets",
    reps: "10–15 reps",
    calories: "~6 kcal/min",
    checklist: [
      "Keep your elbows tucked close to your sides",
      "Curl slowly and squeeze at the top for 1 second",
      "Lower the weight with control — don't drop it",
      "Keep your back straight, avoid swinging",
    ],
  },
  {
    id: "squat",
    name: "Squat",
    short: "Legs",
    emoji: "🦵",
    imageUrl: `${publicUrl}/Squat.jpg`,
    description: "A fundamental lower-body move that works your quads, glutes, and core.",
    youtubeUrl: "https://youtu.be/xqvCmoLULNY?si=NmXOMObwcGDcLSwL",
    difficulty: "Beginner",
    muscles: ["Quads", "Glutes", "Hamstrings", "Core"],
    sets: "3 sets",
    reps: "12–15 reps",
    calories: "~8 kcal/min",
    checklist: [
      "Keep your feet shoulder-width apart, toes slightly out",
      "Push your knees out in line with your toes",
      "Keep your chest up and back straight throughout",
      "Lower until thighs are parallel to the floor",
    ],
  },
  {
    id: "pushup",
    name: "Push-up",
    short: "Upper body",
    emoji: "🏋🏻‍♂️",
    imageUrl: `${publicUrl}/pushup.jpg`,
    description: "Classic bodyweight press that trains chest, shoulders, and triceps.",
    youtubeUrl: "https://youtu.be/lsRAK6cr5kY?si=tbTxhh4WDFBTXNOK",
    difficulty: "Intermediate",
    muscles: ["Chest", "Triceps", "Shoulders", "Core"],
    sets: "3 sets",
    reps: "10–20 reps",
    calories: "~7 kcal/min",
    checklist: [
      "Place hands slightly wider than shoulder-width apart",
      "Keep your body in a straight line — no sagging hips",
      "Lower your chest until it nearly touches the floor",
      "Exhale as you push back up to the starting position",
    ],
  },
  {
    id: "lunges",
    name: "Lunges",
    short: "Legs",
    emoji: "🧘🏽‍♀️",
    imageUrl: `${publicUrl}/Lunge.png`,
    description: "Alternating step exercise that builds single-leg strength and balance.",
    youtubeUrl: "https://youtu.be/9gglI77Kzq8?si=1rpluCADtCTs7woL",
    difficulty: "Beginner",
    muscles: ["Quads", "Glutes", "Hamstrings", "Calves"],
    sets: "3 sets",
    reps: "10–12 reps each leg",
    calories: "~7 kcal/min",
    checklist: [
      "Step forward far enough so your knee stays behind your toes",
      "Lower your back knee toward (not onto) the floor",
      "Keep your torso upright and core engaged",
      "Push through your front heel to return to standing",
    ],
  },
  {
    id: "deadlift",
    name: "Deadlift",
    short: "Back",
    emoji: "🏋️",
    imageUrl: `${publicUrl}/deadlift.jpeg`,
    description: "A fundamental strength exercise that targets your entire posterior chain including back, glutes, and hamstrings.",
    youtubeUrl: "https://youtu.be/op9kVnSso6Q",
    difficulty: "Intermediate",
    muscles: ["Lower Back", "Glutes", "Hamstrings", "Core"],
    sets: "3 sets",
    reps: "8–12 reps",
    calories: "~10 kcal/min",
    checklist: [
      "Keep your back straight — no rounding at any point",
      "Push the floor away rather than pulling the bar up",
      "Keep the bar close to your body throughout the lift",
      "Lock out hips and knees fully at the top",
    ],
  },
  {
    id: "shoulder-press",
    name: "Shoulder Press",
    short: "Shoulders",
    emoji: "🏋️‍♀️",
    imageUrl: `${publicUrl}/shoulder_press.jpeg`,
    description: "A dumbbell overhead press that builds shoulder strength and stability.",
    youtubeUrl: "https://youtu.be/qEwKCR5JCog",
    difficulty: "Intermediate",
    muscles: ["Shoulders", "Triceps", "Upper Chest", "Core"],
    sets: "3 sets",
    reps: "8–12 reps",
    calories: "~6 kcal/min",
    checklist: [
      "Start with elbows at 90° and upper arms parallel to the floor",
      "Press dumbbells straight up until arms are nearly fully extended",
      "Keep your core engaged — avoid arching your lower back",
      "Lower with control back to the 90° starting position",
    ],
  },
  {
    id: "side-lunge",
    name: "Side Lunge",
    short: "Legs",
    emoji: "🦵",
    imageUrl: `${publicUrl}/sidelunge.png`,
    description: "A lateral lunge that targets the inner thighs, glutes, and improves hip mobility.",
    youtubeUrl: "",
    difficulty: "Intermediate",
    muscles: ["Glutes", "Quads", "Inner Thighs", "Hamstrings"],
    sets: "3 sets",
    reps: "10–12 reps each side",
    calories: "~7 kcal/min",
    checklist: [
      "Face the camera and step out wide to one side",
      "Bend the working knee toward 90 degrees — keep it over your toes",
      "Keep the other leg straight",
      "Keep your chest up and back straight",
      "Push back to standing and repeat",
    ],
  },
  {
    id: "glute-bridge",
    name: "Glute Bridge",
    short: "Glutes",
    emoji: "🍑",
    imageUrl: `${publicUrl}/glute_bridge.webp`,
    description: "A floor-based exercise that strengthens the glutes, hamstrings, and lower back while stabilizing the core.",
    youtubeUrl: "",
    difficulty: "Beginner",
    muscles: ["Glutes", "Hamstrings", "Lower Back", "Core"],
    sets: "3 sets",
    reps: "12–15 reps",
    calories: "~5 kcal/min",
    checklist: [
      "Lie on your back with knees bent, feet flat and hip-width apart",
      "Press through your heels to lift your hips toward the ceiling",
      "Squeeze your glutes at the top — avoid arching your lower back",
      "Lower with control back to the starting position",
    ],
  },
];

export function getExerciseById(id) {
  return EXERCISES.find((e) => e.id === id) || null;
}
